import { mockOfficeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-overdue';
const CONV_ID = 'conv-1';
const MD_BLOCK_ID = 'blk-overdue-md';
const LIST_BLOCK_ID = 'blk-overdue-list';
const markdownText = 'I found **3 overdue inspections** that need immediate attention. Here they are:';
const recordListBlock = {
    type: 'record_list',
    block_id: LIST_BLOCK_ID,
    block_index: 1,
    title: 'Overdue Inspections',
    items: [
        {
            resource_type: 'inspection',
            resource_id: 'insp-101',
            title: 'Annual Fire Alarm Inspection',
            subtitle: 'Building A - Main Office',
            url: '/inspections/101',
            status: { label: 'Overdue', color: '#E53E3E' },
            meta: 'Due: Jan 15, 2025'
        },
        {
            resource_type: 'inspection',
            resource_id: 'insp-204',
            title: 'Quarterly Sprinkler Inspection',
            subtitle: 'Building B - Warehouse',
            url: '/inspections/204',
            status: { label: 'Overdue', color: '#E53E3E' },
            meta: 'Due: Feb 1, 2025'
        },
        {
            resource_type: 'inspection',
            resource_id: 'insp-310',
            title: 'Fire Extinguisher Service',
            subtitle: 'Building C - Annex',
            url: '/inspections/310',
            status: { label: 'Overdue', color: '#E53E3E' },
            meta: 'Due: Dec 20, 2024'
        }
    ],
    total_count: 3,
    truncated: false
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(recordListBlock, 100),
    makeStreamEnd(RESPONSE_ID, 2, mockOfficeAgent)
];
export const scenario = {
    name: 'Office Assistant — Overdue Inspections',
    description: 'Navigation query with streaming markdown followed by an atomic record list block.',
    conversations: mockConversations,
    userMessage: 'Show me all overdue inspections',
    agentIdentity: mockOfficeAgent,
    sseSequence
};
